export const convertCoordinatesToString = (coordinates: number[][]): string => {
  return coordinates
    .map((coord) => coord.map((num) => Math.trunc(num)).join(';'))
    .join(';')
}
